import { render, staticRenderFns } from "./insights-default.vue?vue&type=template&id=37db4c82"
import script from "./insights-default.vue?vue&type=script&lang=js"
export * from "./insights-default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports